import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Button from '../components/Button.react';

import Stepper from './Stepper.react';
import Survey from './Survey.react';
import Modal from '../components/Modal.react';
import { selectAnswer as selectAnswerAction } from '../../common/healthCheck/actions';
import QuestionnaireOverlay from './QuestionnaireOverlay';

const DESCRIPTION_MODAL_ID = 'hint-modal';

class Page extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { showOverlay: true };
  }

  static propTypes = {
    hasData: RPT.bool,
    history: RPT.object,
    match: RPT.object,
    questionnaireData: RPT.any,
    rehydrated: RPT.bool,
    selectAnswer: RPT.func,
  }

  componentWillReceiveProps(nextProps) {
    const {
      hasData,
      history: { push },
      match,
      rehydrated,
    } = nextProps;

    if (!hasData && rehydrated) {
      const backLink = `/${match.params.field_id}/project-health-check`;
      push(backLink);
    }
  }

  // TODO: fetchQuestionnaireData if it is not present in componentDidMount

  render() {
    const { questionnaireData, match, selectAnswer } = this.props;

    const surveyIndex = questionnaireData.size && questionnaireData.findIndex(
      ca => ca.get('question_id') === match.params.id,
    );
    const survey = questionnaireData.size && questionnaireData.get(surveyIndex).toJS();
    const previousSurveyId = (questionnaireData.size && (surveyIndex - 1 >= 0))
      ? questionnaireData.getIn([surveyIndex - 1, 'question_id']) : '';
    const lastQuestion = !(questionnaireData.size && surveyIndex + 1 < questionnaireData.size);
    const nextSurveyId = !lastQuestion
      ? questionnaireData.getIn([surveyIndex + 1, 'question_id']) : 'result';

    if (!survey) return <div />;

    return (
      <div>
        <QuestionnaireOverlay />
        <div className="block-questionary-header">
          <Stepper questionNumber={questionnaireData.size} activeQuestion={surveyIndex} />
          <div className="container">
            <div className="questionary-header">
              <h2>
                <strong>{surveyIndex + 1}</strong>
                <span>
                  {survey.label}
                  <small>{survey.question}</small>
                </span>
              </h2>
              {!!survey.description && (
                <a
                  key={`key-for-bounce-button${surveyIndex}`}
                  data-target={`#${DESCRIPTION_MODAL_ID}`}
                  data-toggle="modal"
                  className="btn btn-fixed bounceIn"
                >
                  Doplňující informace
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="block-questionary">
          <div className="container">
            <div className="option-list">

              {survey.answers.map((answer, index) => <Survey
                  key={`${survey.question_id}-${answer.value}`}
                  questionId={survey.question_id}
                  result={survey.result}
                  answer={answer}
                  position={index}
                  selectAnswer={selectAnswer}
                />)}
            </div>
          </div>
        </div>
        <div className="block-questionary-control">
          <div className="container">
            <Button
              id=""
              kind="primary"
              disabled={!surveyIndex}
              className="btn btn-gray-brightest"
              link={previousSurveyId}
            >
              <i className="icon-arrow-left" />
              Zpět
            </Button>
            <Button
              id=""
              kind="primary"
              disabled={!survey.result}
              className="btn btn-red"
              link={survey.result ? nextSurveyId : null}
            >
              {lastQuestion ? 'Zobrazit výsledky' : 'Další otázka'}
              <i className="icon-arrow-right" />
            </Button>
          </div>
        </div>
        {!!survey.description && (
          <Modal modalId={DESCRIPTION_MODAL_ID} title={survey.label}>
            <p>{survey.description}</p>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasData: state.healthCheck.questionnaireData.size > 0,
  questionnaireData: state.healthCheck.questionnaireData,
  rehydrated: state.healthCheck.rehydrated,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    selectAnswer: selectAnswerAction,
  },
  dispatch,
);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Page),
);
